import { BaseDto } from '../base.dto';
import { ChannelTypeDto } from '../channelType.dto';
import { BillingSubscriptionDto } from '../billing-subscription';
import { BillingSubscriptionMerchantDto } from '../billing-subscription-merchant';

export class BillingProductDto extends BaseDto {
  name: string;
  displayName?: string;
  description?: string;
  imageUrl?: string;
  learnMoreUrl?: string;
  isIntegration: boolean;
  active: boolean;
  billingSubscriptionMerchants?: BillingSubscriptionMerchantDto[];
  channelType?: ChannelTypeDto;
  billingSubscription?: BillingSubscriptionDto[];
}
